import React, { useState, useCallback } from 'react'

import { Bin } from '../icons/Bin'
import { Folder } from '../icons/Folder'

import { ConfirmModal } from './ConfirmModal'
import { Button, OrangeButton } from './Button'

export const ConfirmButton = ({
  initOpen = false,
  // modal api
  onCloseRequest,
  children, // Button can also have children but ConfirmModal uses it instead.
  title,
  titleTrad,
  onConfirm,
  confirmDisabled,
  // button api
  onClick,
  fullWidth,
  variant,
  tradId,
  buttonChildren,
  upper = true,
  bold = true,
  loading = false,
  disabled = false,
  link = false,
  to,
  relative,
  icon = null,
  ButtonComponent = Button,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(initOpen)
  const open = useCallback(() => setIsOpen(true), [])
  const close = useCallback(() => setIsOpen(false), [])
  const finalOnConfirm = (e) => {
    onConfirm(e)
    close()
  }

  return (
    <>
      {isOpen && (
        <ConfirmModal
          title={title}
          titleTrad={titleTrad}
          onConfirm={finalOnConfirm}
          confirmDisabled={confirmDisabled}
          onCloseRequest={close}
        >
          {children}
        </ConfirmModal>
      )}
      <ButtonComponent
        onClick={open}
        fullWidth={fullWidth}
        variant={variant}
        tradId={tradId}
        upper={upper}
        bold={bold}
        loading={loading}
        disabled={disabled}
        link={link}
        to={to}
        relative={relative}
        icon={icon}
        {...props}
      >
        {buttonChildren}
      </ButtonComponent>
    </>
  )
}

export const DeleteButton = (props) => (
  <ConfirmButton
    ButtonComponent={OrangeButton}
    icon={<Bin />}
    {...props}
  />
)

export const ArchiveButton = (props) => (
  <ConfirmButton
    ButtonComponent={OrangeButton}
    icon={<Folder />}
    {...props}
  />
)
